// My queue (T2): this station's kitted builds, in the lead's order and then by need-by date.
import { useBuilds } from '../../api/queries';
import { EmptyState, ErrorPanel, Loading, PageHeader } from '../../design/components';
import { BuildCard } from './BuildCard';

const REFRESH_MS = 30_000;

export function QueuePage({ station }: { station: string }) {
    const builds = useBuilds({ stations: [station] }, REFRESH_MS);
    return (
        <section className="sf-stack" aria-labelledby="queue-heading">
            <PageHeader id="queue-heading" title={`My queue at ${station}`} />
            {builds.isPending ? <Loading what="the queue" /> : null}
            {builds.isError ? <ErrorPanel error={builds.error} title="The queue couldn’t be loaded." /> : null}
            {builds.data?.length === 0 ? (
                <EmptyState>
                    Nothing kitted for {station} yet. Builds appear here once Procurement delivers their kit.
                </EmptyState>
            ) : null}
            {builds.data && builds.data.length > 0 ? (
                <ul className="sf-grid" style={{ listStyle: 'none', padding: 0, margin: 0 }} aria-label="Builds">
                    {builds.data.map((build) => (
                        <li key={build.buildId}>
                            <BuildCard build={build} to={`/floor/builds/${build.buildId}`} />
                        </li>
                    ))}
                </ul>
            ) : null}
        </section>
    );
}
